/* Paved Roads — collection-page JS.
   Scroll-to handler, pill filter, in-stock toggle, sort, like-but panels, compare bar. */

(function () {
  if (window.pavedRoadsInitialized) return;
  window.pavedRoadsInitialized = true;

  var SESSION_KEY = 'pavedRoadsCompare';

  // ---- Variant pair toggle (segmented control inside cards) ----
  function setCardVariant(card, variant) {
    if (!card || !variant) return;
    card.setAttribute('data-variant-active', variant);
    card.querySelectorAll('[data-variant-switch]').forEach(function (btn) {
      var match = btn.getAttribute('data-variant-switch') === variant;
      btn.classList.toggle('is-active', match);
      btn.setAttribute('aria-selected', match ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var switchBtn = e.target.closest('[data-variant-switch]');
    if (!switchBtn) return;
    var card = switchBtn.closest('[data-paved-roads-card]');
    setCardVariant(card, switchBtn.getAttribute('data-variant-switch'));
  });

  // ---- Color swatch → preview variant inside card (image + price + links) ----
  function applySwatch(card, scope, swatch) {
    if (!card || !scope || !swatch) return;
    var url = swatch.getAttribute('data-variant-url');
    var img = swatch.getAttribute('data-variant-image');
    var priceCurrent = swatch.getAttribute('data-variant-price-current');
    var priceWas = swatch.getAttribute('data-variant-price-was');
    var priceSave = swatch.getAttribute('data-variant-price-save');

    var imageLinks = card.querySelectorAll('a.paved-roads-card__image[data-variant-show="' + scope + '"]');
    imageLinks.forEach(function (link) {
      if (url) link.setAttribute('href', url);
      var imgEl = link.querySelector('img.paved-roads-card__image-img');
      if (imgEl && img) {
        imgEl.removeAttribute('srcset');
        imgEl.setAttribute('sizes', '(max-width: 700px) 100vw, (max-width: 1024px) 50vw, 33vw');
        imgEl.src = img;
      }
    });

    if (url) {
      card.querySelectorAll('.paved-roads-card__name a[data-variant-show="' + scope + '"], a.paved-roads-card__cta[data-variant-show="' + scope + '"]').forEach(function (a) {
        a.setAttribute('href', url);
      });
    }

    var priceRow = card.querySelector('.paved-roads-card__price-row[data-variant-show="' + scope + '"]');
    if (priceRow) {
      var cur = priceRow.querySelector('.paved-roads-card__price-current');
      if (cur && priceCurrent) cur.textContent = priceCurrent;
      var was = priceRow.querySelector('.paved-roads-card__price-was');
      if (was) {
        if (priceWas) { was.textContent = priceWas; was.style.display = ''; }
        else { was.style.display = 'none'; }
      }
      var sav = priceRow.querySelector('.paved-roads-card__price-save');
      if (sav) {
        if (priceSave) { sav.textContent = 'Save ' + priceSave; sav.style.display = ''; }
        else { sav.style.display = 'none'; }
      }
    }

    card.querySelectorAll('[data-pr-swatch][data-pr-swatch-scope="' + scope + '"]').forEach(function (s) {
      var match = s === swatch;
      s.classList.toggle('is-active', match);
      s.setAttribute('aria-pressed', match ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-pr-swatch]');
    if (!swatch) return;
    e.preventDefault();
    var card = swatch.closest('[data-paved-roads-card]');
    var scope = swatch.getAttribute('data-pr-swatch-scope') || 'primary';
    applySwatch(card, scope, swatch);
  });

  // Resolve a like-but route's variant-target → toggle the destination card
  // to its sibling handle. The variant-target stores the SIBLING product
  // handle; we figure out which variant button to click by matching against
  // the destination card's sibling-image href.
  function maybeToggleVariantOnArrival(target, siblingHandle) {
    if (!target || !siblingHandle) return;
    // The sibling image link's href includes /products/{sibling-handle}
    var siblingImg = target.querySelector('[data-variant-show="sibling"][href*="/products/' + siblingHandle + '"]');
    if (siblingImg) setCardVariant(target, 'sibling');
  }

  // ---- Scroll-to (tier picks, like-but routes, merch band CTA) ----
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-paved-roads-scroll]');
    if (!trigger) return;
    var selector = trigger.getAttribute('data-paved-roads-scroll');
    if (!selector) return;
    var target = document.querySelector(selector);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var variantTarget = trigger.getAttribute('data-variant-target');
    if (variantTarget) maybeToggleVariantOnArrival(target, variantTarget);
  });

  // ---- "I like this, but..." panels ----
  function closeAllLikeBut() {
    document.querySelectorAll('[data-paved-roads-like-but].is-open').forEach(function (el) {
      el.classList.remove('is-open');
      var panel = el.querySelector('.paved-roads-card__like-but-panel');
      if (panel) panel.hidden = true;
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-paved-roads-like-but-toggle]');
    if (toggle) {
      var wrapper = toggle.closest('[data-paved-roads-like-but]');
      var isOpen = wrapper.classList.contains('is-open');
      closeAllLikeBut();
      if (!isOpen) {
        wrapper.classList.add('is-open');
        var panel = wrapper.querySelector('.paved-roads-card__like-but-panel');
        if (panel) panel.hidden = false;
      }
      return;
    }
    var closeBtn = e.target.closest('[data-paved-roads-like-but-close]');
    if (closeBtn) {
      e.stopPropagation();
      closeAllLikeBut();
      return;
    }
    if (!e.target.closest('[data-paved-roads-like-but]')) {
      closeAllLikeBut();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllLikeBut();
  });

  // ---- Filter pills ----
  function applyFilters() {
    var activePill = document.querySelector('[data-paved-roads-pill].is-active');
    var pillFilter = activePill ? activePill.getAttribute('data-paved-roads-pill') : 'all';
    var instockEl = document.querySelector('[data-paved-roads-instock]');
    var instockOnly = instockEl && instockEl.checked;

    document.querySelectorAll('[data-paved-roads-card]').forEach(function (card) {
      var traits = (card.getAttribute('data-traits') || '').split(/\s+/).filter(Boolean);
      var matchesPill = pillFilter === 'all' || traits.indexOf(pillFilter) !== -1;
      var matchesStock = !instockOnly || card.getAttribute('data-available') === '1';
      card.hidden = !(matchesPill && matchesStock);
    });
  }

  document.querySelectorAll('[data-paved-roads-pill]').forEach(function (pill) {
    pill.addEventListener('click', function () {
      document.querySelectorAll('[data-paved-roads-pill]').forEach(function (p) {
        p.classList.remove('is-active');
      });
      pill.classList.add('is-active');
      applyFilters();
    });
  });

  // ---- In-stock toggle ----
  document.querySelectorAll('[data-paved-roads-instock]').forEach(function (cb) {
    cb.addEventListener('change', applyFilters);
  });

  // ---- Sort ----
  document.querySelectorAll('[data-paved-roads-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var grid = document.querySelector('[data-paved-roads-grid]');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-paved-roads-card]'));
      var mode = select.value;
      cards.sort(function (a, b) {
        if (mode === 'price-asc') {
          return parseInt(a.getAttribute('data-price'), 10) - parseInt(b.getAttribute('data-price'), 10);
        }
        if (mode === 'price-desc') {
          return parseInt(b.getAttribute('data-price'), 10) - parseInt(a.getAttribute('data-price'), 10);
        }
        if (mode === 'newest') {
          return parseInt(b.getAttribute('data-created-at'), 10) - parseInt(a.getAttribute('data-created-at'), 10);
        }
        return 0;
      });
      cards.forEach(function (card) { grid.appendChild(card); });
    });
  });

  // ---- Compare bar ----
  var compareBar = document.querySelector('[data-paved-roads-compare-bar]');
  if (compareBar) {
    var compareCountEl = compareBar.querySelector('[data-paved-roads-compare-count]');
    var compareItemsEl = compareBar.querySelector('[data-paved-roads-compare-items]');
    var compareCta = compareBar.querySelector('[data-paved-roads-compare-cta]');
    var compareClear = compareBar.querySelector('[data-paved-roads-compare-clear]');
    var compareBaseUrl = compareCta ? compareCta.getAttribute('data-base-url') : '/pages/compare-bikes';
    var compareMax = parseInt(compareBar.getAttribute('data-paved-roads-compare-max'), 10) || 3;

    var selected = loadCompare();
    syncCompareUI();

    function loadCompare() {
      try {
        var raw = sessionStorage.getItem(SESSION_KEY);
        if (!raw) return [];
        var arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    }

    function saveCompare() {
      try {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(selected));
      } catch (e) {
        // ignore
      }
    }

    function syncCompareUI() {
      // sync checkboxes
      document.querySelectorAll('[data-paved-roads-compare]').forEach(function (cb) {
        var handle = cb.getAttribute('data-handle');
        cb.checked = selected.some(function (item) { return item.handle === handle; });
      });

      // sync bar
      if (compareCountEl) compareCountEl.textContent = String(selected.length);
      if (compareItemsEl) {
        compareItemsEl.innerHTML = '';
        selected.forEach(function (item) {
          var el = document.createElement('div');
          el.className = 'paved-roads-compare-bar__item';
          var label = document.createElement('span');
          label.textContent = item.title;
          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'paved-roads-compare-bar__item-remove';
          remove.setAttribute('aria-label', 'Remove ' + item.title);
          remove.textContent = '×';
          remove.addEventListener('click', function () {
            removeCompare(item.handle);
          });
          el.appendChild(label);
          el.appendChild(remove);
          compareItemsEl.appendChild(el);
        });
      }

      if (compareCta) {
        if (selected.length > 0) {
          var ids = selected.map(function (item) { return encodeURIComponent(item.handle); }).join(',');
          var sep = compareBaseUrl.indexOf('?') >= 0 ? '&' : '?';
          compareCta.setAttribute('href', compareBaseUrl + sep + 'ids=' + ids);
        } else {
          compareCta.setAttribute('href', compareBaseUrl);
        }
      }

      compareBar.classList.toggle('is-active', selected.length > 0);
    }

    function addCompare(handle, title) {
      if (selected.length >= compareMax) {
        alert('You can compare up to ' + compareMax + ' bikes at a time.');
        return false;
      }
      if (selected.some(function (item) { return item.handle === handle; })) return true;
      selected.push({ handle: handle, title: title });
      saveCompare();
      syncCompareUI();
      return true;
    }

    function removeCompare(handle) {
      selected = selected.filter(function (item) { return item.handle !== handle; });
      saveCompare();
      syncCompareUI();
    }

    document.querySelectorAll('[data-paved-roads-compare]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var handle = cb.getAttribute('data-handle');
        var title = cb.getAttribute('data-bike');
        if (cb.checked) {
          var ok = addCompare(handle, title);
          if (!ok) cb.checked = false;
        } else {
          removeCompare(handle);
        }
      });
    });

    if (compareClear) {
      compareClear.addEventListener('click', function () {
        selected = [];
        saveCompare();
        syncCompareUI();
      });
    }
  }
})();
